import type { Cloneable } from '@bindoc-projects/util-domain-lib';

export class BdAddress implements Cloneable<BdAddress> {
  public static fromObject(
    obj:
      | {
          street?: string;
          postalCode?: string;
          city?: string;
          location?: [number, number];
          note?: string;
          administrativeDistrictId?: number;
        }
      | any,
  ) {
    return new BdAddress(
      obj.street,
      obj.postalCode,
      obj.city,
      obj.location,
      obj.note,
      obj.administrativeDistrictId,
    );
  }

  constructor(
    public street?: string,
    public postalCode?: string,
    public city?: string,
    public location?: number[],
    public note?: string,
    public administrativeDistrictId?: number,
  ) {}

  public isEmpty(): boolean {
    return (
      this.street === undefined &&
      this.city === undefined &&
      this.postalCode === undefined
    );
  }

  public toString(): string {
    if (this.isEmpty()) {
      return '';
    } else {
      return `${this.street}, ${this.postalCode} ${this.city}`;
    }
  }

  public clone(...args): BdAddress {
    return new BdAddress(
      this.street,
      this.postalCode,
      this.city,
      this.location,
      this.note,
      this.administrativeDistrictId,
    );
  }
}
